export default __webpack_public_path__ + "static/quote-event-place-holder-image-27b3d0539fb9f7ca9e63177766969e30.jpg";